export default __webpack_public_path__ + "static/media/icon-plan-business.7462c3ab.svg";